// Invoice related types and interfaces
import { Booking } from "./booking";

export interface InvoiceLine {
  id?: number;
  invoice_id?: number;
  booking_id?: number;
  description: string;
  quantity: number;
  unit_price: number;
  vat_percentage: number;
  cost_type?: string;
  moneybird_invoice_line_id?: string;
}

export interface Invoice {
  id?: number;
  created_at?: string;
  booking_id: number;
  company_id?: number;
  currency: string;
  payment_term?: PaymentTerm;
  due_date?: string;
  custom_payment_terms?: string;
  moneybird_id?: string; // Legacy field, kept for compatibility
  moneybird_invoice_id?: string;
  moneybird_invoice_invoice_id?: string; // Moneybird invoice_id field from response
  moneybird_sync_status?: 'pending' | 'synced' | 'failed' | 'updated' | 'cancelled';
  moneybird_synced_at?: string;
  moneybird_payment_status?: 'open' | 'paid' | 'partial' | 'overdue' | 'cancelled';
  moneybird_error_message?: string;
  // Additional Moneybird fields
  moneybird_invoice_date?: string;
  moneybird_due_date?: string;
  moneybird_reminder_count?: number;
  moneybird_next_reminder?: string;
  moneybird_paid_at?: string;
  moneybird_sent_at?: string;
  moneybird_reference?: string;
  lines: InvoiceLine[];
  booking?: Booking; // Relation to the booking
}

export enum PaymentTerm {
  DAYS_7 = "net_7",
  DAYS_14 = "net_14",
  DAYS_30 = "net_30",
  DAYS_60 = "net_60",
  IMMEDIATE = "immediate",
  END_OF_MONTH = "end_of_month",
  CUSTOM = "custom"
}

export const paymentTermLabels: Record<PaymentTerm, string> = {
  [PaymentTerm.DAYS_7]: "Net 7 days",
  [PaymentTerm.DAYS_14]: "Net 14 days",
  [PaymentTerm.DAYS_30]: "Net 30 days",
  [PaymentTerm.DAYS_60]: "Net 60 days",
  [PaymentTerm.IMMEDIATE]: "Immediate payment",
  [PaymentTerm.END_OF_MONTH]: "End of month",
  [PaymentTerm.CUSTOM]: "Custom terms",
}; 